import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const verifyMagicLink = {
  name: "verifyMagicLink" as const,
  input: z.object({ token: z.string() }),
  output: z.object({
    authToken: z.string(),
    vendor: z.object({
      id: zExt.objectId(),
      email: z.string(),
      name: z.string().nullable(),
    }),
  }),
};
